import React, { useContext } from 'react';
import { Typography, Box, CircularProgress } from '@mui/material';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import { jwtDecode } from 'jwt-decode';

function ProtectedRoute({ children, requiredPermission }) {
  const { userPermissions, user, isLoading } = useContext(AuthContext);
  const location = useLocation();

  const token = localStorage.getItem('access_token') || localStorage.getItem('jwtToken');
  const isTokenValid = () => {
    if (!token) return false;
    try {
      const decoded = jwtDecode(token);
      return decoded.exp * 1000 > Date.now();
    } catch {
      return false;
    }
  };

  // Wait for auth check to finish before redirecting
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (!user || !isTokenValid()) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // When requiredPermission is specified, check it; otherwise allow access
  if (requiredPermission) {
    const hasPermission = userPermissions[requiredPermission] || false;
    if (!hasPermission) {
      return (
        <Typography variant="h6" color="error" sx={{ p: 2, textAlign: 'center' }}>
          You do not have the required permissions to access this feature.
        </Typography>
      );
    }
  }

  return children;
}

export default ProtectedRoute;